import React from 'react'
import Link from 'react-router/lib/Link'

const SideListItem  = ({ item }) => (
  <Link
    key={item.get('id')}
    to={`/fees-presets/${item.get('id')}`}
    className="list-group-item"
    activeClassName="active"
  >
    {item.get('code')}
  </Link>
)

export default SideListItem



// WEBPACK FOOTER //
// ./src/containers/FeesPresets/side-list-item.js